import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Option } from '../../models';

@Component({
  selector: 'partnerhub-checkbox-button-group',
  templateUrl: './checkbox-button-group.component.html',
  styleUrls: ['./checkbox-button-group.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxButtonGroupComponent), multi: true }],
})
export class CheckboxButtonGroupComponent implements OnInit, OnDestroy, ControlValueAccessor {
   unsubscriber = new Subject();
  public get _horizontal(): boolean {
    if (this.horizontal === '' || this.horizontal) {
      return true;
    }
    return false;
  }

  private readonly complete$ = new Subject();

  public formControl = new FormControl();

  @Input() public groupName = '';

  @Input() public horizontal: boolean | string = false;

  @Input() public options: Option[] = [];

  // TODO: Disabled Options
  // TODO: Horizontal

  constructor() {}

  public ngOnDestroy(): void {
    this.complete$.next(true);

    this.complete$.complete();
  }

  public ngOnInit(): void {
    this.formControl.valueChanges
      .pipe()
      .subscribe(() => this.onChange(this.formControl.value));
  }

  public onChange = (_: string) => {};

  public onTouch = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  public writeValue(value: string): void {
    this.formControl.setValue(value);

    this.onChange(this.formControl.value);
  }
}
